import type { RumInitConfiguration } from '@datadog/browser-rum';
import { datadogRum } from '@datadog/browser-rum';

const applicationId = import.meta.env.VITE_DATADOG_APPLICATION_ID;
const clientToken = import.meta.env.VITE_DATADOG_CLIENT_TOKEN;
const site = import.meta.env.VITE_DATADOG_SITE;
const service = import.meta.env.VITE_DATADOG_SERVICE;
const env = import.meta.env.VITE_SMSC_ENV;
const smartscriptVersionInfo = import.meta.env.VITE_SMSC_VERSION_INFO;
const sessionSampleRate = 100;
const sessionReplaySampleRate = 100;

export const datadogInit = async (): Promise<void> => {
	if (env === 'prod') {
		const initConfiguration: RumInitConfiguration = {
			applicationId,
			clientToken,
			site,
			service,
			env,
			version: smartscriptVersionInfo,
			sessionSampleRate,
			sessionReplaySampleRate,
			trackUserInteractions: true,
			trackResources: true,
			trackLongTasks: true,
			defaultPrivacyLevel: 'mask-user-input',
			usePartitionedCrossSiteSessionCookie: true,
		};

		datadogRum.init(initConfiguration);
	}
};
